export default __webpack_public_path__ + "static/media/airbnb.fb3dc60a.png";